import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import styled from 'styled-components';
import { GlobalStyles } from './design/globalStyles';
import { designTokens } from './design/designTokens';
import { UserProvider } from './contexts/UserContext';
import { tenantService } from './services/tenantService';
import { batchService } from './services/batchService';
import VerticalSidebar from './components/VerticalSidebar';
import Dashboard from './components/Dashboard';
import Calendar from './components/Calendar';
import BatchManagement from './components/BatchManagement';
import FeedManagement from './components/FeedManagement';
import GrowthTrackerAdvanced from './components/GrowthTrackerAdvanced';
import Analytics from './components/Analytics';
import FinancialAnalytics from './components/FinancialAnalytics';
import FarmProfile from './components/FarmProfile';
import './App.css';

const AppContainer = styled.div`
  min-height: 100vh;
  background: ${designTokens.colors.background.secondary};
  font-family: ${designTokens.typography.fontFamily.primary};
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;

function App() {
  // Initialize tenant service on app start
  useEffect(() => {
    // Ensure tenant service is initialized
    const currentTenant = tenantService.getCurrentTenant();
    if (!currentTenant) {
      console.log('Initializing default tenant...');
    } else {
      console.log('Tenant service initialized with tenant:', currentTenant.name);
      // Reload batch service now that tenant is ready
      batchService.reloadForCurrentTenant();
    }
  }, []);

  return (
    <>
      <GlobalStyles />
      <UserProvider>
        <AppContainer>
          <Router>
          <Routes>
          <Route path="/" element={
            <VerticalSidebar pageTitle="Home">
              <Dashboard />
            </VerticalSidebar>
          } />
          <Route path="/calendar" element={
            <VerticalSidebar pageTitle="Calendar">
              <Calendar />
            </VerticalSidebar>
          } />
          <Route path="/batch-management" element={
            <VerticalSidebar pageTitle="Batch Management">
              <BatchManagement />
            </VerticalSidebar>
          } />
          <Route path="/feed-management" element={
            <VerticalSidebar pageTitle="Feed Management">
              <FeedManagement />
            </VerticalSidebar>
          } />
          <Route path="/growth-tracking" element={
            <VerticalSidebar pageTitle="Growth Tracking">
              <GrowthTrackerAdvanced />
            </VerticalSidebar>
          } />
          <Route path="/production-analysis" element={
            <VerticalSidebar pageTitle="Production Analysis">
              <Analytics />
            </VerticalSidebar>
          } />
          <Route path="/financial-analysis" element={
            <VerticalSidebar pageTitle="Financial Analysis">
              <FinancialAnalytics />
            </VerticalSidebar>
          } />
          <Route path="/farm-profile" element={
            <VerticalSidebar pageTitle="Farm Profile">
              <FarmProfile />
            </VerticalSidebar>
          } />
          </Routes>
          </Router>
        </AppContainer>
      </UserProvider>
    </>
  );
}

export default App;